import { useDataChange } from 'Simple/Data'
import { FEE_MODE_RANGES } from 'Data/constants.js'

export function useOnChangeStandard(props) {
  let change = useDataChange({
    context: 'provider_account',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.fee_mode = 'STANDARD'
      next.card_fee_percent = null
      next.ach_fee_percent = null
    })
  }
}
export function useOnChangePlatformFee(props) {
  let change = useDataChange({
    context: 'provider_account',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.fee_mode = 'PLATFORM_FEE'
      next.card_fee_percent =
        next.card_fee_percent || FEE_MODE_RANGES.PLATFORM_FEE.CARD.DEFAULT
      next.ach_fee_percent =
        next.ach_fee_percent || FEE_MODE_RANGES.PLATFORM_FEE.ACH.DEFAULT
    })
  }
}

export function useOnChangeSurcharge(props) {
  let change = useDataChange({
    context: 'provider_account',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.fee_mode = 'SURCHARGE'
      next.card_fee_percent =
        next.card_fee_percent || FEE_MODE_RANGES.SURCHARGE.CARD.DEFAULT
      next.ach_fee_percent = null
    })
  }
}
